import type { ReactNode } from 'react'
import Logo from '../ui/Logo'
import { useAuth } from '../auth/AuthContext'

function Cadre({ titre, children }: { titre: string; children: ReactNode }) {
  return (
    <div className="min-h-screen bg-[#F6F6F7] flex items-center justify-center px-4 font-baloo text-kdp-dark">
      <div className="w-full max-w-md bg-white border border-[#E7E7E7] rounded-2xl p-6 text-center">
        <Logo className="w-20 text-kdp-red mx-auto mb-3" />
        <h1 className="text-xl font-bold mb-2">{titre}</h1>
        <div className="text-[#6B6B6B] space-y-3">{children}</div>
      </div>
    </div>
  )
}

export function Chargement() {
  return (
    <div className="min-h-screen flex items-center justify-center font-baloo text-[#6B6B6B]">Chargement…</div>
  )
}

export function ConfigurationManquante() {
  return (
    <Cadre titre="Configuration à compléter">
      <p>L'adresse du projet Supabase et la clé publique ne sont pas encore renseignées.</p>
      <p className="text-sm">Fichier attendu : <code>.env.local</code> (modèle : <code>.env.example</code>).</p>
    </Cadre>
  )
}

export function AccesRefuse() {
  const { session, signOut } = useAuth()
  return (
    <Cadre titre="Accès non autorisé">
      <p>Le compte <b className="text-kdp-dark">{session?.user.email}</b> existe, mais il n'est pas inscrit dans la liste des personnes autorisées de l'ERP, ou il a été désactivé.</p>
      <p>Demandez à l'administrateur de vous ajouter.</p>
      <button onClick={signOut} className="mt-2 border border-[#E7E7E7] rounded-xl px-4 py-2 font-semibold text-kdp-dark">Se déconnecter</button>
    </Cadre>
  )
}
